<template>
  <div class="page-container">
    <div class="error-image" style="background-image: url(/img/error-one.png)"></div>
    <div class="text-content">
      <div class="text-one">错误代码：404</div>
      <div class="text-two">您可能输入了错误的地址，或者页面已经移动。</div>
      <div class="text-link" @click="back()">去主页看看</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
  },
  name: "abnormal",
  inject: ['reload'],
  data() {
    return {
    }
  },
  methods: {
    ...mapActions([
    ]),
    // 返回
    back() {
      this.$router.push({ path: '/' })
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters([
    ])
  },
  created() {
  },
  mounted() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" rel="stylesheet/scss">
@import "../../assets/scss/variables";
@import "../../assets/scss/mixins";
.page-container {
  width: 100%;
  height: 100%;
  padding-top: 220px;
  background-color: $white;
  .error-image {
    width: 100%;
    height: 200px;
    background-position: center;
    background-repeat: no-repeat;
  }
  .text-content {
    width: 100%;
    text-align: center;
  }

  .text-one {
    padding-top: 24px;
    padding-bottom: 12px;
    font-size: 20px;
    color: #2f2f4f;
    font-weight: bold;
  }
  .text-two {
    padding-bottom: 24px;
    font-size: 14px;
    color: #697386;
  }
  .text-link {
    font-size: 16px;
    color: #0066ff;
  }

}
</style>